import page from './page'
import appList from './app-list'
import mpFollowAd from './mp-follow-ad'

export default {
    install: function (Vue) {
        Vue.component('my-page', page)
        Vue.component('app-list', appList)
        Vue.component('yunser-mp-ad', mpFollowAd)
    }
}



// WEBPACK FOOTER //
// ./src/components/index.js